import loadable from "@loadable/component";

const Performance = loadable(() => import("./Performance.page"));

export default { component: Performance };
